import { DISCOUNT_CODE_STORAGE_KEY } from '@/constants';
import { discountCodeCookie } from '@/cookies';

export function getDiscountCodeFromUrl(): string | null {
  if (typeof window === 'undefined') return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(DISCOUNT_CODE_STORAGE_KEY);
}

export function getDiscountCodeFromCookie(): string | null {
  if (typeof window === 'undefined') return null;
  return discountCodeCookie.get(DISCOUNT_CODE_STORAGE_KEY) || null;
}

export function saveDiscountCodeToCookie(code: string): void {
  discountCodeCookie.set(DISCOUNT_CODE_STORAGE_KEY, code);
}

export function removeDiscountCodeCookie(): void {
  discountCodeCookie.set(DISCOUNT_CODE_STORAGE_KEY, '', {
    expires: -1,
  });
}

export function getCurrentDiscountCode(): string | null {
  const codeFromUrl = getDiscountCodeFromUrl();
  const codeFromCookie = getDiscountCodeFromCookie();

  return codeFromUrl || codeFromCookie;
}

export function isValidDiscountCode(code: string | null): boolean {
  return code !== null && code.trim() !== '';
}
